var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseRoundButton',{ref:"beaconIcon",staticClass:"beacon",attrs:{"size":45,"tooltip-text":_vm.tooltipText,"icon":"life-buoy","is-white":""},nativeOn:{"click":function($event){return _vm.toggle()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }